// extracted by mini-css-extract-plugin
module.exports = {"container":"bannerDescription_container__nkw1R"};